<template>
    <div>
<!--        "<strong>{{ $_.get(activity, "payload.fullname") }} </strong>" visitor was unblocked by-->
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>-->
        <span v-html="$t('notification.visitorUnblocked', { visitor: $_.get(activity, 'payload.fullname'), agent:$_.get(activity, 'actorUser.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "VisitorUnBlocked",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
